import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
/***showroom virtual */
import showroom from "../../images/showroom/staria.png";
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/staria/banner/web2.webp";
import Slider2 from "../../images/modelos/staria/banner/web3.webp";
import Slider3 from "../../images/modelos/staria/banner/web_1.webp";
import Slider4 from "../../images/modelos/staria/banner/web5.webp";
import Slider5 from "../../images/modelos/staria/banner/web4.webp";
/****Fotos calidad de tiempo ****/
import CalidadTiempo1 from "../../images/modelos/staria/calidad/fotos-calidad-de-tiempo.webp";
import CalidadTiempo2 from "../../images/modelos/staria/calidad/fotos-calidad-de-tiempo2.webp";
import Galeria1 from "../../images/modelos/staria/galeria/galeria-calidad-de-tiempo.webp";
import Galeria2 from "../../images/modelos/staria/galeria/galeria-calidad-de-tiempo1.webp";
import Galeria3 from "../../images/modelos/staria/galeria/galeria-calidad-de-tiempo2.webp";
import Galeria4 from "../../images/modelos/staria/galeria/galeria-calidad-de-tiempo3.webp";
import Galeria5 from "../../images/modelos/staria/galeria/galeria-calidad-de-tiempo4.webp";
import Galeria6 from "../../images/modelos/staria/galeria/galeria-calidad-de-tiempo5.webp";
/****Fotos disenio ****/
import Frontal from "../../images/modelos/staria/disenio/Frontal/banner-frontal.webp"
import Frontal1 from "../../images/modelos/staria/disenio/Frontal/frontal1.webp"
import Frontal2 from "../../images/modelos/staria/disenio/Frontal/frontal2.webp"
import Frontal3 from "../../images/modelos/staria/disenio/Frontal/frontal3.webp"
import Frontal4 from "../../images/modelos/staria/disenio/Frontal/frontal4.webp"
import LateralBanner from "../../images/modelos/staria/disenio/Lateral/banner-lateral.webp"
import Lateral1 from "../../images/modelos/staria/disenio/Lateral/lateral1.webp"
import Lateral2 from "../../images/modelos/staria/disenio/Lateral/lateral2.webp"
import Lateral3 from "../../images/modelos/staria/disenio/Lateral/lateral3.webp"
import Lateral4 from "../../images/modelos/staria/disenio/Lateral/lateral4.webp"
import PosteriorBanner from "../../images/modelos/staria/disenio/Posterior/banner-posterios.webp"
import Posterior1 from "../../images/modelos/staria/disenio/Posterior/posterior1.webp"
import Posterior2 from "../../images/modelos/staria/disenio/Posterior/posterior2.webp"
import Posterior3 from "../../images/modelos/staria/disenio/Posterior/posterior3.webp"
import Posterior4 from "../../images/modelos/staria/disenio/Posterior/posterior4.webp"
import Interior1 from "../../images/modelos/staria/disenio/Interior/interior1.webp"
import Interior2 from "../../images/modelos/staria/disenio/Interior/interior2.webp"
import Interior3 from "../../images/modelos/staria/disenio/Interior/interior3.webp"
import Interior4 from "../../images/modelos/staria/disenio/Interior/interior4.webp"
import Interior5 from "../../images/modelos/staria/disenio/Interior/interior5.webp"
/****Fotos rendimiento ****/
import Rendimiento1 from "../../images/modelos/staria/rendimiento/rendimiento1.webp"
import Rendimiento2 from "../../images/modelos/staria/rendimiento/rendimiento2.webp"
import Rendimiento3 from "../../images/modelos/staria/rendimiento/redimiento3.webp"
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/staria/seguridad/seguridad1.webp"
import Seguridad2 from "../../images/modelos/staria/seguridad/seguridad2.webp"
import Seguridad3 from "../../images/modelos/staria/seguridad/seguridad3.webp"
import Seguridad4 from "../../images/modelos/staria/seguridad/seguridad4.webp"
import Seguridad5 from "../../images/modelos/staria/seguridad/seguridad5.webp"
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/staria/conveniencia/conveniencia-1.webp";
import Conveniencia2 from "../../images/modelos/staria/conveniencia/conveniencia-2.webp";
import Conveniencia3 from "../../images/modelos/staria/conveniencia/conveniencia-3.webp";
import Conveniencia4 from "../../images/modelos/staria/conveniencia/conveniencia-4.webp";
import Conveniencia5 from "../../images/modelos/staria/conveniencia/conveniencia-5.webp";
import Conveniencia6 from "../../images/modelos/staria/conveniencia/conveniencia-6.webp";
import ConvenienciaFinal from "../../images/modelos/staria/conveniencia/foto-final-conveniencia.webp";
/****Ficha técnica ****/
import { Accordion, Button, Card } from "react-bootstrap";
import VideoStaria from "../../images/modelos/staria/video-staria.mp4"
import "./StylesStaria.css"

function InfoStaria() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <link rel="preload" as="image" href={Slider1} />
            <link rel="preload" as="image" href={CalidadTiempo1} />
            <link rel="preload" as="image" href={CalidadTiempo2} />
            <link rel="preload" as="image" href={Galeria1} />
            <link rel="preload" as="image" href={Galeria2} />
            <link rel="preload" as="image" href={Galeria3} />
            <link rel="preload" as="image" href={Galeria4} />
            <link rel="preload" as="image" href={Galeria5} />
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <div>
                            <Image
                                src={Slider1}
                                alt="All New Staria vista posterior"
                                className="banner"
                                id="img-carrusel"
                                fluid
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">All-New STARIA</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={7}
                            className="my-auto vehiculo-item text-md-center px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/staria-ficha-tecnica.e7b3c9ec.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/cotizador/staria"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </Link>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/test-drive/staria"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra">Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">ALL NEW STARIA</h2>
                            <p>Lleva el espacio hacia otro mundo</p>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Con la All New STARIA sientes que te embarcas en un nuevo viaje al espacio, en donde los
                                pasajeros viajarán con la máxima comodidad, que disfrutarán del placer de la
                                conversación y pasar momentos enriquecedores.
                            </p>
                            <p>
                                En este espacio, las posibilidades son tan ilimitadas como los diferentes estilos de
                                vida de sus propietarios. STARIA es un gran salto hacia el futuro de la movilidad de los
                                vehículos multiuso.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>

                            <video loop controls
                                style={
                                    {
                                        position: "relative",
                                        width: "100%",
                                        objectFit: "cover",
                                    }
                                }
                            >
                                <source src={VideoStaria} type="video/mp4" />

                            </video>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    De un paso hacia el espacio
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Cada detalle de la cabina ha sido reinventado para brindar una experiencia de manejo
                                    más fácil, seguro y divertido. Innovación por dentro y por fuera, esa es la señal de
                                    un auténtico liderazgo en diseño.
                                </p>
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image className="animacion-imagen img-fluid2" src={CalidadTiempo1} alt="Staria Emocionante" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image className="animacion-imagen img-fluid2" src={CalidadTiempo2} alt="Staria Innovacion" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="specs-subtitle mt-3 px-3 px-md-0">
                                    Inigualable
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Desde el momento en que miras por primera vez a STARIA, te das cuenta de que es
                                    inigualable. No es una imitación ni una derivación, sino una creación verdaderamente
                                    original: un producto de diseño inspirado.
                                    <br />
                                    Para las familias aventureras STARIA es la VAN perfecta para todos esos momentos
                                    inolvidables.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Staria Slider 1"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Staria Slider 2"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Staria Slider 3"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Staria Slider 4"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Staria Slider 5"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria6}
                                            alt="Staria Slider 5"
                                            className="galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Staria Slider 1"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Staria Slider 2"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Staria Slider 3"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Staria Slider 4"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Staria Slider 5"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria6}
                                            alt="Staria Slider 5"
                                            className="galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Diseño Exterior</h2>
                            <h2 className="model-title-sub">Diseño en una nueva dirección .</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Para romper claramente con el pasado, los diseñadores del STARIA se inspiraron en la
                                forma de una curva para evidenciar el avance del diseño de los vehículos multiuso (MPV)
                                hacia una dirección completamente nueva. STARIA trae un moderno diseño aerodinámico,
                                tecnología eficiente, ofrece seguridad, comodidad, poder, elegancia y calidad. Así es
                                STARIA, más espaciosa y con estilo futurista.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
                    <a href="https://my.matterport.com/show/?m=YW2yPtEjhfL" target="_brown" rel="noopener noreferrer">
                        <center>
                            <Image src={showroom} alt="Showroom Virtual Staria" fluid width={700} height={350} />
                        </center>
                    </a>
                </Container>
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="px-0">
                            <Accordion defaultActiveKey="1" className="acordeon-disenio">
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                            <Image src={Frontal} alt="Staria Frontal" fluid />
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Container className="my-4 my-md-5">
                                            <Row>
                                                <Col md={12} className="text-center mb-4 mb-md-1">
                                                    <Image
                                                        src={Frontal1}
                                                        alt="Staria Tecnologia"
                                                        fluid
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4} className="mt-3 mt-md-4 text-center">
                                                    <Image className="animacion-imagen" src={Frontal2}
                                                        alt="Staria Frontal 1" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Rejilla frontal color carrocería

                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4 text-center">
                                                    <Image className="animacion-imagen" src={Frontal3}
                                                        alt="Faros halógenos Staria" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Faros halógenos
                                                        <br />
                                                        Luces automáticas
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4 text-center">
                                                    <Image className="animacion-imagen" src={Frontal4}
                                                        alt="Espejos con luz direccional" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                                        Espejos plegables y ajustables eléctricamente
                                                        <br />
                                                        Espejos con luz direccional

                                                    </h3>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="px-0">
                            <Accordion defaultActiveKey="1" className="acordeon-disenio">
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                            <Image src={LateralBanner} alt="Vista Lateral Staria" fluid />
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Container className="my-4 my-md-5">
                                            <Row>
                                                <Col md={12} className="text-center mb-4 mb-md-1">
                                                    <Image src={Lateral1} alt="Vista Lateral izquierda" fluid />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        src={Lateral2}
                                                        alt="Staria espejos"
                                                        fluid
                                                        className="animacion-imagen"
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0 text-center">
                                                        Espejos eléctricos
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image className="animacion-imagen"
                                                        src={Lateral3} alt="Staria Manijas" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0 text-center">
                                                        Manijas color carrocería
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image className="animacion-imagen"
                                                        src={Lateral4} alt="Aros de aleación Staria" fluid />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0 text-center">
                                                        Aros de aleación 15”
                                                    </h3>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="px-0">
                            <Accordion defaultActiveKey="1" className="acordeon-disenio">
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Button} variant="link" eventKey="0">
                                            <Image src={PosteriorBanner} alt="Vista posterior Staria" fluid />
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="0">
                                        <Container className="my-4 my-md-5">
                                            <Row>
                                                <Col md={12} className="text-center mb-4 mb-md-1">
                                                    <Image
                                                        src={Posterior1}
                                                        alt="Vista posterior Staria"
                                                        fluid
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        className="animacion-imagen"
                                                        src={Posterior2}
                                                        alt="Luz de stop Staria"
                                                        fluid
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0 text-center">
                                                        Tercera luz stop
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        className="animacion-imagen"
                                                        src={Posterior3}
                                                        alt="Staria deportivo"
                                                        fluid
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0 text-center">
                                                        Spoiler deportivo
                                                    </h3>
                                                </Col>
                                                <Col md={4} className="mt-3 mt-md-4">
                                                    <Image
                                                        className="animacion-imagen"
                                                        src={Posterior4}
                                                        alt="Guardachoque Staria"
                                                        fluid
                                                    />
                                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0 text-center">
                                                        Guardachoque color carrocería
                                                    </h3>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="pt-3 pt-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="model-title mb-0">Diseño Interior</h2>
                                <h2 className="model-title-sub">Practicidad en su máxima expresión.</h2>
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    Diseñado para la máxima comodidad y practicidad, STARIA no se equivoca al rodearlo
                                    con una variedad de funciones inteligentes que brindan un espacio inesperado.
                                </p>
                                <Image src={Interior1} alt="Staria Interior" fluid />
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-2 mt-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior2} alt="Staria tablero" fluid className="animacion-imagen" />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Tablero de instrumentos con pantalla LCD 4,2"
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior3} alt="Staria Pantalla" fluid className="animacion-imagen" />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Pantalla táctil de 8"
                                    Apple Car Play/Android Auto
                                    Bluetooth con reconocimiento de voz
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior4} alt="Staria Luces" fluid className="animacion-imagen" />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Control de audio al volante
                                    Volante regulable en
                                    altura y profundidad
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-4">
                            <Col md={12} className="mt-3 mt-md-4">
                                <Image src={Interior5} alt="Staria Interior" fluid />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">No existe nada igual
                            </h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Maximiza el rendimiento mediante el diseño aerodinámico y varios componentes que mejoran
                                el flujo de aire. El motor garantiza un excelente rendimiento de conducción y eficiencia
                                de combustible, con mayor potencia, torque y dimensiones la destacan.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4">
                        <Col md={6} className="mt-4 mt-md-4">
                            <Image src={Rendimiento1} alt="Staria tablero" fluid className="animacion-imagen" />
                            <h3 className="specs-text mt-3 px-3 px-md-0">
                                Transmisión Manual 6 velocidades + reversa
                            </h3>
                        </Col>
                        <Col md={6} className="mt-4 mt-md-4">
                            <Image src={Rendimiento2} alt="Staria Pantalla" fluid className="animacion-imagen" />
                            <span className="specs-text mt-3 text-center">
                                Tipo 2.2 CRDi Diesel
                            </span>
                            <span className="specs-text text-center">
                                Cilindraje (CC) 2.199
                            </span>
                            <span className="specs-text text-center">
                                Potencia máxima (hp@rpm) 175 @ 3.800
                            </span>
                            <span className="specs-text text-center">
                                Torque máximo (Nm@rpm) 431 @ 1.500 - 2.500
                            </span>
                            <span className="specs-text text-center">
                                Sistema de distribución Cadena
                            </span>
                        </Col>
                    </Row>
                    <Row className="pb-3 pb-md-4 d-flex mt-md-4 justify-content-center">
                        <Col md={12} className="mt-4 mt-md-4">
                            <Image
                                src={Rendimiento3}
                                alt="Staria Banner"
                                className="w-100"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Seguridad y confort en movimiento</h2>
                            <h2>Protección en la que se puede confiar</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Los dispositivos de seguridad, como cámara de retro, freno multicolisión (MCB), control
                                electrónico de estabilidad (ESC), asistente de arranque en pendiente (HAC) y cinturones
                                de seguridad de 3 puntos, proporcionan una gran seguridad para los ocupantes.
                            </p>
                        </Col>
                    </Row>
                    <Row className='pt-5'>
                        <Col md={6}>
                            <Image className="animacion-imagen" src={Seguridad1} alt="Staria Frenos" fluid />
                            <p className="specs-text mt-3 px-3 px-md-0 text-center">
                                Asistente de arranque en pendiente (HAC)
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image className="animacion-imagen" src={Seguridad2} alt="Staria Cinturones" fluid />
                            <p className="specs-text mt-3 px-3 px-md-0 text-center">
                                Freno multicolisión (MCB)
                            </p>
                        </Col>
                    </Row>
                    <Row className='pt-5'>
                        <Col md={6}>
                            <Image className="animacion-imagen" src={Seguridad3} alt="Staria Frenos" fluid />
                            <p className="specs-text mt-3 px-3 px-md-0 text-center">
                                Cámara de retroceso con líneas guía
                            </p>
                        </Col>
                        <Col md={6}>
                            <Image className="animacion-imagen" src={Seguridad4} alt="Staria Cinturones" fluid />
                            <p className="specs-text mt-3 px-3 px-md-0 text-center">
                                Control Electrónico de estabilidad (ESC)
                            </p>
                        </Col>
                    </Row>
                    <Row className='pt-5 centrar-global'>
                        <Col md={6}>
                            <Image className="animacion-imagen" src={Seguridad5} alt="Staria Frenos" fluid />
                            <p className="specs-text mt-3 px-3 px-md-0 text-center">
                                Cinturones de seguridad de 3 puntos
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Todos los días es el día de la liberación
                            </h2>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                Las funciones inteligentes de STARIA son realmente liberadoras, le dan la libertad de
                                concentrarse en cosas más importantes como: los largos asientos deslizantes brindan una
                                medida adicional de flexibilidad para reconfigurar el espacio de la cabina, ventanas
                                panorámicas, puertos de carga USB a bordo para que todos estén contentos durante el
                                viaje.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={4}>
                                <Image
                                    className="animacion-imagen"
                                    src={Conveniencia1}
                                    alt="Staria mandos integrados volante"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Asientos 2da a 4ta fila plegables
                                    (opción de plegado completamente plano)
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image className="animacion-imagen" src={Conveniencia2} alt="Staria botón encendido"
                                    fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Ventanas panorámicas
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image className="animacion-imagen" src={Conveniencia3} alt="Staria ducto ventilación"
                                    fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    11 pasajeros
                                    4 filas de asientos
                                </h3>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <Image className="animacion-imagen" src={Conveniencia4} alt="Staria ducto ventilación"
                                    fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Asientos 2da y 4ta fila deslizables <br />
                                    Asientos 4ta fila abatibles
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image className="animacion-imagen" src={Conveniencia5} alt="Staria ducto ventilación"
                                    fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Toma de 12v/Tomas auxiliares USB
                                </h3>
                            </Col>
                            <Col md={4}>
                                <Image className="animacion-imagen" src={Conveniencia6} alt="Staria ducto ventilación"
                                    fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0 text-center">
                                    Asiento del conductor regulable en altura <br />
                                    Asientos 1ra fila reclinables y deslizables
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="mt-4 mb-4 mb-md-5">
                        <Col md={12}>
                            <Image src={ConvenienciaFinal} alt="Staria Conveniencia" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </span>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoStaria;